<!--
  Verweis auf die passende Anleitung — direkt unter der Seitenüberschrift.

  Die Anleitungen liegen auf der Website (/hilfe/, statisch, auch als PDF),
  nicht im Kundenbereich. Wer eingeloggt ist, soll sie trotzdem ohne Suchen
  finden (Karsten, 04.09.2026): auf jeder Seite der Verweis auf genau die
  Anleitung, die zu dieser Seite gehört, dazu „Anleitungen" in der
  Hauptnavigation. Öffnet in neuem Reiter, damit die Anmeldung nicht verloren
  geht, wenn man zwischen Anleitung und Seite hin und her wechselt.
-->
<script lang="ts">
  let { slug, text }: { slug: string; text: string } = $props();
  const basis = 'https://it-karsten-fischer.de/hilfe/';
</script>

<p class="hilfe-link">
  📖 <a href={slug ? `${basis}${slug}/` : basis} target="_blank" rel="noopener">{text}</a>
  <span class="leise klein">(öffnet in neuem Fenster)</span>
</p>

<style>
  .hilfe-link {
    margin: -0.5rem 0 1.25rem;
    font-size: 0.98rem;
  }
</style>
